import axios from "axios";
import axiosRetry from "axios-retry";

// axiosRetryを使用するためのカスタムaxios
const customAxios = axios.create();
axiosRetry(customAxios, { retryDelay: axiosRetry.exponentialDelay });

export default customAxios;
